import React from 'react';

import { SERVICE_GROUP_ID } from '@/constants';
import { ServiceGroup } from '@/types/serviceGroup';
import { useAppSelector } from '@/store';
import { authStore } from '@/store/auth';

import { NONGLS } from '../Presentaition';

// TODO: GU省かれてるけど問題ないか確認
const subscribableServices = [
  SERVICE_GROUP_ID.hodai,
  SERVICE_GROUP_ID.emba,
  SERVICE_GROUP_ID.hodaiplus,
];

type Props = {
  service: ServiceGroup;
};

export const NONGLSContainer: React.FC<Props> = ({ service }) => {
  const isManager = useAppSelector(authStore.selectors.isManagerSelector);
  const isMember = useAppSelector(authStore.selectors.isMemberSelector);

  const showMemberWarning =
    isMember && subscribableServices.includes(service.id);

  return (
    <NONGLS
      service={service}
      showMemberWarning={showMemberWarning}
      isManager={isManager}
    />
  );
};
